import { combineReducers } from 'redux'
import {
    WHITELIST_GET, WHITELIST_ADD, WHITELIST_DELL, WHITELIST_EDIT,
    WHITELIST_MASTER_LIST_DROPDOWN_GET
} from '../actions/whitelistAction'

const getMasterWhitelist = (state = { val: [], load: false }, action) => {
    switch (action.type) {
        case WHITELIST_MASTER_LIST_DROPDOWN_GET:
            return { val: action.val, load: action.load }
        default:
            return state
    }
}

const getWhitelist = (state = { val: [], load: false }, action) => {
    switch (action.type) {
        case WHITELIST_GET:
            return { val: action.val, load: action.load }
        default:
            return state
    }
}

const addWhitelist = (state = { val: [], load: false }, action) => {
    switch (action.type) {
        case WHITELIST_ADD:
            return { val: action.val, load: action.load }
        default:
            return state
    }
}

const DelWhitelist = (state = { val: [], load: false }, action) => {
    switch (action.type) {
        case WHITELIST_DELL:
            return { val: action.val, load: action.load }
        default:
            return state
    }
}

const EditWhitelist = (state = { val: [], load: false }, action) => {
    switch (action.type) {
        case WHITELIST_EDIT:
            return { val: action.val, load: action.load }
        default:
            return state
    }
}


const whitelistReducer = combineReducers({
    getMasterWhitelist,
    getWhitelist,
    addWhitelist,
    DelWhitelist,
    EditWhitelist
})

export default whitelistReducer